// extracted by mini-css-extract-plugin
module.exports = {"menu":"SiteMenu-module--menu--1jl2U","menu__category":"SiteMenu-module--menu__category--1V-sl","menu__icon":"SiteMenu-module--menu__icon--1Sezj"};